(() => {
  if (window.CaratKinCustomiseRing) return;
  window.CaratKinCustomiseRing = true;

  const ringState = {
    step: 1,
    shape: "",
    carat: "",
    color: "",
    clarity: "",
    metal: "",
    purity: "",
    band: "",
    size: "",
    engraving: "",
  };

  const shapeLabels = { round: "Round", radiant: "Radiant", marquise: "Marquise", pear: "Pear", oval: "Oval", emerald: "Emerald", cushion: "Cushion", heart: "Heart" };
  const metalLabels = { rose: "Rose Gold", white: "White Gold", yellow: "Yellow Gold" };
  // Design band labels -> engine BANDS keys (the engine only knows Plain/Pave/Regal).
  const bandEngine = { "Plain": "Plain", "Pavé": "Pave", "Pave": "Pave", "Regal": "Regal" };

  const requiredByStep = {
    1: ["shape", "carat", "color", "clarity"],
    2: ["metal", "purity", "band"],
    3: ["size"],
  };

  // Colour + clarity vocabularies flip at 1ct, mirroring the rate matrix:
  // sub-1ct is graded DEF/GH at VVS-VS; from 1ct up it is D/E/F/G at VS or VVS.
  const GRADES = {
    sub1: {
      colours: [["DEF", "Colourless"], ["GH", "Near colourless"]],
      clarities: [["VVS-VS", "Exceptional clarity"]],
    },
    over1: {
      colours: [["D", "Colourless"], ["E", "Colourless"], ["F", "Colourless"], ["G", "Near colourless"]],
      clarities: [["VS", "Excellent clarity"], ["VVS", "Exceptional clarity"]],
    },
  };

  let RATES = null;
  try {
    const node = document.getElementById("ck-pricing-data");
    if (node) RATES = JSON.parse(node.textContent);
  } catch (e) {
    console.error("[customise-ring] pricing data failed to parse", e);
  }

  const money = (value) => Number.isFinite(Number(value)) ? `₹${Math.round(Number(value)).toLocaleString("en-IN")}` : "";
  const caratNumber = (v) => { const m = String(v == null ? "" : v).match(/[\d.]+/); return m ? parseFloat(m[0]) : 0; };
  const stepComplete = (step) => requiredByStep[step].every((field) => Boolean(ringState[field]));
  const canEnterStep = (step) => step <= 1 || (stepComplete(1) && (step <= 2 || stepComplete(2)));

  /* ---- dynamic colour/clarity per carat ---------------------------------- */

  function gradeSetFor(carat) {
    return caratNumber(carat) >= 1 ? GRADES.over1 : GRADES.sub1;
  }

  // Rebuild the colour and clarity choice groups to match the selected carat.
  // A previously chosen grade is kept if it still exists, otherwise cleared so
  // the customer re-picks (and step one reports incomplete until they do).
  function renderGrades() {
    const set = gradeSetFor(ringState.carat);
    [["color", "Diamond colour", set.colours], ["clarity", "Diamond clarity", set.clarities]].forEach(([attr, label, items]) => {
      const container = document.querySelector(`.select-options[aria-label="${label}"]`);
      if (!container) return;
      container.innerHTML = items.map(([value, sub]) =>
        `<button class="choice-card" type="button" data-option="${attr}" data-value="${value}" aria-pressed="false"><strong>${value}</strong><small>${sub}</small></button>`
      ).join("");
      const stillValid = items.some(([v]) => v === ringState[attr]);
      if (!stillValid) ringState[attr] = "";
      if (ringState[attr]) {
        const active = container.querySelector(`[data-value="${ringState[attr]}"]`);
        if (active) { active.classList.add("is-selected"); active.setAttribute("aria-pressed", "true"); }
      }
    });
  }

  /* ---- pricing ----------------------------------------------------------- */

  function currentQuote() {
    const engine = window.CKRingConfigurator;
    if (!engine || !RATES) return null;
    const ready = requiredByStep[1].every((k) => ringState[k]) && ringState.metal && ringState.purity && ringState.band;
    if (!ready) return null;

    const sel = {
      shape: shapeLabels[ringState.shape] || ringState.shape,
      caratSize: caratNumber(ringState.carat),
      colour: ringState.color,
      clarity: ringState.clarity,
      metal: metalLabels[ringState.metal] || "Rose Gold",
      purity: ringState.purity,
      bandStyle: bandEngine[ringState.band] || "Plain",
      ringSize: ringState.size ? Number(ringState.size) : "Free Sizer",
    };
    const result = engine.calculate(sel, RATES);
    if (result.error) { console.warn("[customise-ring]", result.error); return null; }
    return { sel, result };
  }

  function updatePricing() {
    const quote = currentQuote();
    window.CaratKinCustomRingQuote = quote;

    const components = quote ? {
      diamond: quote.result.centreStone,
      metal: quote.result.gold,
      band: quote.result.making + quote.result.bandDiamonds,
    } : {};

    document.querySelectorAll("[data-component-price]").forEach((element) => {
      const formatted = money(components[element.dataset.componentPrice]);
      element.textContent = formatted;
      element.hidden = !formatted;
    });

    const total = quote ? money(quote.result.total) : "";
    document.querySelectorAll("[data-estimated-price], [data-summary-price]").forEach((element) => {
      element.textContent = total || "—";
    });

    const addButton = document.querySelector("[data-add-custom]");
    if (addButton) addButton.disabled = !(stepComplete(3) && quote);

    document.dispatchEvent(new CustomEvent("ck:price-change", { detail: quote }));
  }

  /* ---- live preview (SVG morphs with shape, metal and band) -------------- */

  const SVGNS = "http://www.w3.org/2000/svg";
  const STONE_HL = '<circle cx="209" cy="78" r="6" fill="#fff" opacity=".85"/>';

  // Each entry is the inner SVG for the centre stone: an outline filled with the
  // shared sparkle gradient, a few facet lines, and a highlight. Drawn in the
  // same rotated coordinate space as the original hexagon (centred ~220,93).
  const SHAPES = {
    round:
      '<circle cx="220" cy="93" r="41" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<circle cx="220" cy="93" r="24" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width="2"/>' +
      '<path d="M220 52 L220 134 M179 93 L261 93 M191 64 L249 122 M249 64 L191 122" stroke="#fff" stroke-opacity=".5" stroke-width="2"/>',
    oval:
      '<ellipse cx="220" cy="93" rx="32" ry="49" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<ellipse cx="220" cy="93" rx="18" ry="30" fill="none" stroke="#fff" stroke-opacity=".5" stroke-width="2"/>' +
      '<path d="M220 44 L220 142 M188 93 L252 93" stroke="#fff" stroke-opacity=".45" stroke-width="2"/>',
    marquise:
      '<path d="M220 44 C240 68 252 82 252 93 C252 104 240 118 220 142 C200 118 188 104 188 93 C188 82 200 68 220 44 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M220 44 L220 142 M196 93 L244 93" stroke="#fff" stroke-opacity=".5" stroke-width="2"/>',
    pear:
      '<path d="M220 46 C232 66 250 84 250 106 C250 126 237 142 220 142 C203 142 190 126 190 106 C190 84 208 66 220 46 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M220 60 L206 108 L220 138 L234 108 Z" fill="none" stroke="#fff" stroke-opacity=".45" stroke-width="2"/>',
    emerald:
      '<path d="M200 50 H240 L254 66 V120 L240 136 H200 L186 120 V66 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M198 66 H242 M198 120 H242 M198 66 V120 M242 66 V120" stroke="#fff" stroke-opacity=".45" stroke-width="2"/>',
    radiant:
      '<path d="M202 50 H238 L254 66 V120 L238 136 H202 L186 120 V66 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M186 66 L202 50 M254 66 L238 50 M186 120 L202 136 M254 120 L238 136 M220 50 V136 M186 93 H254" stroke="#fff" stroke-opacity=".45" stroke-width="2"/>',
    cushion:
      '<path d="M198 52 H242 A18 18 0 0 1 260 70 V116 A18 18 0 0 1 242 134 H198 A18 18 0 0 1 180 116 V70 A18 18 0 0 1 198 52 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M220 54 L220 132 M182 93 L258 93 M196 68 L244 118 M244 68 L196 118" stroke="#fff" stroke-opacity=".4" stroke-width="2"/>',
    heart:
      '<path d="M220 138 C204 122 182 106 182 84 C182 68 194 58 208 58 C215 58 219 63 220 69 C221 63 225 58 232 58 C246 58 258 68 258 84 C258 106 236 122 220 138 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M220 69 L220 132 M200 74 L214 100 M240 74 L226 100" stroke="#fff" stroke-opacity=".45" stroke-width="2"/>',
    // Neutral brilliant shown before a shape is chosen (a path, not a polygon,
    // so the metal recolour CSS never tints the diamond).
    default:
      '<path d="M220 44 L258 72 L248 120 L220 144 L192 120 L182 72 Z" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="4"/>' +
      '<path d="M220 44 L220 144 M182 72 L258 72 M192 120 L248 120" stroke="#fff" stroke-opacity=".6" stroke-width="2"/>',
  };
  Object.keys(SHAPES).forEach((k) => { SHAPES[k] += STONE_HL; });

  // Band decoration set along the actual shank curve: Plain adds nothing, Pavé
  // lines the band with tiny stones, Regal steps graduated accent stones down
  // each shoulder. Points come from the live path so they always sit true.
  function bandExtra(band, shank) {
    if (!shank || !band || band === "Plain") return "";
    const total = shank.getTotalLength();
    const pt = (l) => shank.getPointAtLength(Math.max(0, Math.min(total, l)));
    if (band === "Pavé" || band === "Pave") {
      let out = "";
      for (let l = 12; l <= total - 12; l += 15) {
        const p = pt(l);
        out += `<circle cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="2.5" fill="#fff" stroke="#cfc9bf" stroke-width=".6"/>`;
      }
      return out;
    }
    if (band === "Regal") {
      let out = "";
      [[12, 4.2], [30, 3.4], [50, 2.7]].forEach(([l, r]) => {
        const a = pt(l), b = pt(total - l);
        out += `<circle cx="${a.x.toFixed(1)}" cy="${a.y.toFixed(1)}" r="${r}" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="1.5"/>`;
        out += `<circle cx="${b.x.toFixed(1)}" cy="${b.y.toFixed(1)}" r="${r}" fill="url(#diamond-sparkle)" stroke="#fff" stroke-width="1.5"/>`;
      });
      return out;
    }
    return "";
  }

  // Restructure the static SVG once (swap the fixed hexagon for scriptable
  // groups), then repaint the stone and band decoration on every change. Metal
  // colour is handled by the section CSS via [data-ring-preview][data-metal].
  function renderPreview() {
    const svg = document.querySelector(".ring-art");
    const rotG = svg && svg.querySelector("g[filter]");
    if (!rotG) return;
    let stone = rotG.querySelector("[data-stone]");
    if (!stone) {
      let el = rotG.querySelector(".ring-stone");
      while (el) { const next = el.nextElementSibling; el.remove(); el = next; }
      const extra = document.createElementNS(SVGNS, "g");
      extra.setAttribute("data-band-extra", "");
      const prong = rotG.querySelector('path[stroke="url(#ring-gold)"]:not(.ring-band)');
      if (prong) rotG.insertBefore(extra, prong); else rotG.appendChild(extra);
      stone = document.createElementNS(SVGNS, "g");
      stone.setAttribute("data-stone", "");
      rotG.appendChild(stone);
    }
    stone.innerHTML = SHAPES[ringState.shape] || SHAPES.default;
    const extra = rotG.querySelector("[data-band-extra]");
    if (extra) extra.innerHTML = bandExtra(ringState.band, rotG.querySelector(".ring-band"));
  }

  /* ---- validation + summary --------------------------------------------- */

  function updateValidation() {
    Object.keys(requiredByStep).forEach((step) => {
      const complete = stepComplete(Number(step));
      document.querySelectorAll(`[data-validation="${step}"]`).forEach((message) => {
        message.classList.toggle("is-hidden", complete);
      });
    });

    document.querySelectorAll("[data-continue]").forEach((button) => {
      const currentStep = Number(button.closest("[data-step-panel]")?.dataset.stepPanel || 1);
      button.disabled = !stepComplete(currentStep);
    });
    document.querySelectorAll("[data-step]").forEach((button) => {
      button.disabled = !canEnterStep(Number(button.dataset.step));
    });
    // The add-to-cart button also needs a valid price, so updatePricing() owns it.
  }

  function updateSummary() {
    const diamondParts = [shapeLabels[ringState.shape], ringState.carat, ringState.color, ringState.clarity].filter(Boolean);
    const values = {
      diamond: diamondParts.length === 4 ? diamondParts.join(", ") : "Not selected",
      metal: ringState.metal && ringState.purity ? `${ringState.purity} ${metalLabels[ringState.metal]}` : "Not selected",
      band: ringState.band ? (ringState.band === "Plain" ? "Classic Solitaire" : ringState.band) : "Not selected",
      size: ringState.size || "Not selected",
      engraving: ringState.engraving.trim() || "None",
    };

    Object.entries(values).forEach(([key, value]) => {
      document.querySelectorAll(`[data-summary="${key}"]`).forEach((element) => { element.textContent = value; });
    });

    document.querySelector("[data-selected-shape]")?.replaceChildren(shapeLabels[ringState.shape] || "—");
    const previewName = document.querySelector("[data-preview-name]");
    if (previewName) {
      previewName.textContent = ringState.shape
        ? (ringState.band ? (ringState.band === "Plain" ? `${shapeLabels[ringState.shape]} Solitaire` : ringState.band) : `${shapeLabels[ringState.shape]} Ring`)
        : "Your Ring Preview";
    }
    const preview = document.querySelector("[data-ring-preview]");
    if (preview) {
      if (ringState.metal) preview.dataset.metal = ringState.metal;
      else delete preview.dataset.metal;
    }
    renderPreview();

    updateValidation();
    updatePricing();
  }

  function syncOption(option, value) {
    ringState[option] = value;
    if (option === "carat") renderGrades();
    document.querySelectorAll(`[data-option="${option}"]`).forEach((button) => {
      const selected = button.dataset.value === value;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
    updateSummary();
  }

  function showStep(step) {
    const nextStep = Math.max(1, Math.min(3, Number(step)));
    if (!canEnterStep(nextStep)) return;
    ringState.step = nextStep;
    document.querySelectorAll("[data-step-panel]").forEach((panel) => {
      const visible = Number(panel.dataset.stepPanel) === nextStep;
      panel.hidden = !visible;
      panel.classList.toggle("is-active", visible);
    });
    document.querySelectorAll("[data-step]").forEach((button) => {
      const stepNumber = Number(button.dataset.step);
      button.classList.toggle("is-current", stepNumber === nextStep);
      button.classList.toggle("is-complete", stepNumber < nextStep && stepComplete(stepNumber));
      button.setAttribute("aria-selected", String(stepNumber === nextStep));
      button.disabled = !canEnterStep(stepNumber);
    });
    document.querySelector(".ring-builder")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function toggleDiamondSizes(button) {
    const group = document.querySelector("[data-diamond-more]");
    if (!group) return;
    const open = button.getAttribute("aria-expanded") !== "true";
    button.setAttribute("aria-expanded", String(open));
    button.textContent = open ? "See Less" : "See More";
    group.classList.toggle("is-open", open);
    group.setAttribute("aria-hidden", String(!open));
  }

  /* ---- add to cart (dynamic product, mirrors the WordPress flow) --------- */

  async function addCustomRingToCart(button) {
    const quote = window.CaratKinCustomRingQuote;
    if (!quote) return;

    const original = button.textContent;
    button.disabled = true;
    button.setAttribute("aria-live", "polite");
    button.textContent = "Adding…";

    // Human-readable properties travel with the cart line so they show in the
    // cart, checkout and the eventual order.
    const properties = {
      "Shape": shapeLabels[ringState.shape] || ringState.shape,
      "Diamond": [ringState.carat, ringState.color, ringState.clarity].filter(Boolean).join(" · "),
      "Metal": `${ringState.purity} ${metalLabels[ringState.metal] || ""}`.trim(),
      "Band style": ringState.band,
      "Ring size": ringState.size,
    };
    if (ringState.engraving.trim()) properties["Engraving"] = ringState.engraving.trim();

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    try {
      // The app recomputes the price server-side and returns a variant to add.
      const created = await fetch(`${root}apps/cart-kin/custom-ring`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ selection: quote.sel, state: ringState, expectedPrice: quote.result.total }),
      });
      if (!created.ok) throw new Error(`custom-ring create failed: ${created.status}`);
      const data = await created.json();
      if (!data || !data.variantId) throw new Error("custom-ring response missing variantId");

      const added = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(data.variantId), quantity: 1, properties }] }),
      });
      if (!added.ok) {
        const problem = await added.json().catch(() => null);
        throw new Error(problem?.description || `cart add failed: ${added.status}`);
      }

      button.textContent = "Added to cart";
      if (window.CaratKinCartDrawer) {
        await window.CaratKinCartDrawer.refresh();
        window.CaratKinCartDrawer.open();
      }
    } catch (error) {
      console.error("[customise-ring]", error);
      button.textContent = "Couldn't add — try again";
      button.disabled = false;
      window.setTimeout(() => { button.textContent = original; }, 2600);
    }
  }

  /* ---- events ------------------------------------------------------------ */

  document.addEventListener("click", (event) => {
    const option = event.target.closest("[data-option]");
    if (option) return syncOption(option.dataset.option, option.dataset.value);
    const stepButton = event.target.closest("[data-step]");
    if (stepButton) return showStep(stepButton.dataset.step);
    const continueButton = event.target.closest("[data-continue]");
    if (continueButton) return showStep(continueButton.dataset.continue);
    const backButton = event.target.closest("[data-back]");
    if (backButton) return showStep(backButton.dataset.back);
    const editButton = event.target.closest("[data-edit-step]");
    if (editButton) return showStep(editButton.dataset.editStep);
    const diamondToggle = event.target.closest("[data-diamond-see-more]");
    if (diamondToggle) return toggleDiamondSizes(diamondToggle);
    const sizeToggle = event.target.closest("[data-see-more]");
    if (sizeToggle) {
      const more = document.querySelector("[data-more-sizes]");
      const open = sizeToggle.getAttribute("aria-expanded") !== "true";
      if (more) more.hidden = !open;
      sizeToggle.setAttribute("aria-expanded", String(open));
      sizeToggle.textContent = open ? "See Less" : "See More";
      return;
    }
    const addButton = event.target.closest("[data-add-custom]");
    if (addButton && !addButton.disabled && stepComplete(3)) {
      // Guests sign in first. The ring being built is remembered and restored
      // below when they come back, so nothing has to be re-picked.
      if (window.CaratKinAuthGate?.intercept({ kind: "custom-ring", state: { ...ringState } }, () => addButton.click())) return;
      return addCustomRingToCart(addButton);
    }
  });

  // Back from sign-in (auth-gate.js): rebuild the ring the shopper had
  // configured. Carat goes before colour and clarity because renderGrades()
  // rebuilds those choices for the chosen carat.
  document.addEventListener("carat-kin:auth-resume", (event) => {
    const saved = event.detail;
    if (!saved || saved.kind !== "custom-ring" || !saved.state) return;
    ["shape", "carat", "color", "clarity", "metal", "purity", "band", "size"].forEach((option) => {
      if (saved.state[option]) syncOption(option, saved.state[option]);
    });
    const engraving = document.querySelector("[data-engraving]");
    if (engraving && saved.state.engraving) {
      engraving.value = saved.state.engraving;
      engraving.dispatchEvent(new Event("input"));
    }
    showStep(3);
  });

  document.querySelector("[data-engraving]")?.addEventListener("input", (event) => {
    ringState.engraving = event.target.value.slice(0, 20);
    const counter = document.querySelector("[data-engraving-count]");
    if (counter) counter.textContent = `${ringState.engraving.length}/20`;
    updateSummary();
  });

  document.querySelectorAll("[data-option]").forEach((button) => button.setAttribute("aria-pressed", "false"));
  renderGrades();
  updateSummary();
})();
